import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./deleteConfirmModal.css";
import { motion, AnimatePresence } from "framer-motion";
import { GoTrash } from "react-icons/go";

export default function DeleteConfirmModal({ onCancel, onDelete }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete();
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="delete-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={(e) => {
          if (e.target.classList.contains("delete-modal-overlay")) onCancel();
        }}
      >
        <motion.div
          className="delete-modal-container"
          initial={{ opacity: 0, scale: 0.85, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.85, y: 20 }}
          transition={{ type: "spring", stiffness: 160, damping: 18 }}
        >
          {/* Icon and Message */}
          <GoTrash className="delete-modal-icon" />
          <p
            className="delete-modal-message"
            dangerouslySetInnerHTML={{ __html: t("serviceModal.deleteQuestion") }}
          />

          {/* Buttons */}
          <div className="delete-modal-buttons">
            <button
              className="delete-modal-cancel-btn"
              onClick={onCancel}
              disabled={loading}
            >
              {t("serviceModal.btnCancel")}
            </button>
            <button
              className="delete-modal-delete-btn"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading
                ? t("serviceModal.btnDeleting")
                : t("serviceModal.btnDeleteConfirm")}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
